module.exports = __webpack_public_path__ + "img/section3.270152c1.png";